import React from "react";
import { Button } from "react-bootstrap";
import DropdownSvg from "../../public/images/Dropdown.svg";
import DropUpSvg from "../../public/images/DropUp.svg";
import styles from "./DropDownButton.module.css";

const DropDownButton = ({
  onClick,
  showDropDown,
  children,
  error,
  classes,
  disabled = false,
  tabIndex,
  height = "",
}) => {
  return (
    <Button
      className={`${styles.dropdownButton} ${styles[classes]}`}
      onClick={disabled ? "" : () => onClick()}
      tabIndex={tabIndex}
      style={height !== "" ? { height: height } : {}}
    >
      <div className={styles.childrenText}>{children}</div>
      <div>
        <img
          alt=""
          src={showDropDown ? DropUpSvg : DropdownSvg}
          style={{ width: "10px" }}
        ></img>
      </div>
    </Button>
  );
};

export default DropDownButton;
